var map = {
	"./32-red.png": 8150,
	"./777.png": 2694,
	"./888.png": 5303,
	"./Frenzino.png": 9744,
	"./bet-mgm.png": 3584,
	"./bet-victor.png": 3788,
	"./betflat.png": 1391,
	"./big-wins.png": 9145,
	"./bilucky.png": 5558,
	"./cosomo-bet.png": 7865,
	"./cosomo.png": 7707,
	"./doctor-spins.png": 342,
	"./donbet.png": 987,
	"./dunder.png": 5393,
	"./electric-spins.png": 2298,
	"./fat-pirat.png": 7739,
	"./froggy-bet.png": 8703,
	"./fun-bet.png": 4822,
	"./galaxy.png": 6839,
	"./grand-ivy.png": 5236,
	"./hyppo-drom.png": 2516,
	"./kings-chip.png": 8844,
	"./leo-vegas.png": 546,
	"./luck-wands.png": 2390,
	"./luky-kings.png": 9817,
	"./moana.png": 1425,
	"./mr-q.png": 7232,
	"./my-stake.png": 4820,
	"./netional-bet.png": 2739,
	"./ocean-breeze.png": 6017,
	"./rolino.png": 3206,
	"./savannaw-wins.png": 1034,
	"./slot-dynamite.png": 4215,
	"./slots-magic.png": 8486,
	"./slottio.png": 4547,
	"./spicy-jackpot.png": 8232,
	"./spin-land.png": 7129,
	"./superb-bet.png": 796,
	"./supra-play.png": 7557,
	"./tiktok-casino.png": 7697,
	"./treasure-spins.png": 3912,
	"./treasure-spins2.png": 4808,
	"./wild-robin.png": 1216,
	"./winner.png": 8938
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4752;